import { render, staticRenderFns } from "./FormAsetuksetMaksutiedot.vue?vue&type=template&id=62bdbc3b&scoped=true&"
import script from "./FormAsetuksetMaksutiedot.vue?vue&type=script&lang=js&"
export * from "./FormAsetuksetMaksutiedot.vue?vue&type=script&lang=js&"
import style0 from "./FormAsetuksetMaksutiedot.vue?vue&type=style&index=0&id=62bdbc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bdbc3b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bdbc3b')) {
      api.createRecord('62bdbc3b', component.options)
    } else {
      api.reload('62bdbc3b', component.options)
    }
    module.hot.accept("./FormAsetuksetMaksutiedot.vue?vue&type=template&id=62bdbc3b&scoped=true&", function () {
      api.rerender('62bdbc3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAsetuksetMaksutiedot.vue"
export default component.exports